import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/cities', { params }),
  sync: () => axios.put('/api/admin/v1/cities', {}),
  getDropDown: () => axios.get('/api/admin/v1/cities/drop-down'),
}
